<template>
<div>

  <section class="content">
    <div class="box info-box">
      <div class="box-header with-border">
        Filter By
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <label for="Branch">Branch</label>
            <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getDataBranchWise(branch)"></v-select>
            
            <has-error
              :form="form"
              field="branch_id"
            ></has-error>
          </div>
          <div class="col-md-3" v-if="user.type == 'admin' || user.role_id == 5">
            <label for="Branch">Group</label>
            <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="changeFilter" required></v-select>
            <has-error
              :form="form"
              field="branch_id"
            ></has-error>
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
      <!-- Default box -->
      <!-- <div class="box" v-if="canAccess('member-collection-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Customer Group List</h3>
          <span class="float-right">
            <button v-if="canAccess('member-collection-create')" type="button" class="btn btn-sm btn-success" @click="newModal">
              <i class="fa fa-plus"></i>
            </button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :line-numbers="true"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Status'">
                    <span
                      v-if="props.row.status == 'active'"
                      class="badge bg-success"
                      >Active</span
                    >
                    <span v-else class="badge bg-danger">InActive</span>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button
                      v-if="canAccess('member-collection-create')"
                      v-show="
                        props.row.collection_center.disbursementStatus ==
                        'false'
                      "
                      type="button"
                      @click="deleteModal(props.row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
                
        </div>
        <div class="box-footer">
          List of all Customer Groups
        </div>
      </div> -->
      <!-- /.box -->

       <!-- Default box -->
      <div class="info-box"  v-if="canAccess('collection-center-member-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Group Member List</h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/collectioncentermember/export/excel`" class="btn btn-box-tool" v-if="canAccess('collection-center-member-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('collection-center-member-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
              <div class="input-group pull-right input-group-sm" style="width: 195px;">
                <input type="text" v-model="member_city_search" @keyup.enter="changeFilter()" name="member_city_search" class="form-control pull-right" placeholder="Search By Member City">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 185px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search By Group City">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th class="hidden-xs">Code </th>
                <th>Name</th>
                <th class="hidden-xs">Group City</th>
                <th>Mem Name</th>
                <th class="hidden-xs">Mem Code</th>
                <th class="hidden-xs">Mobile</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Branch Code</th>
                <th v-if="canAccess('collection-center-member-delete')">Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td class="hidden-xs">{{ row.collection_center.centerCode }}</td>
                <td>{{ row.collection_center.name }}</td>
                <td class="hidden-xs">{{ row.collection_center.city }}</td>

                <td>{{ row.member.name }}</td>
                <td class="hidden-xs">{{ row.member.code }}</td>
                <td class="hidden-xs">{{ row.member.mobile }}</td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.branch.branchCode }}</td>
                <td v-if="canAccess('collection-center-member-delete')">
                  <div class="btn-group">
                    <button
                      v-if="canAccess('collection-center-member-delete')"
                      v-show="row.collection_center.disbursementStatus =='false'"
                      type="button"
                      @click="deleteModal(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->

    </section>        
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add New</h4>
              <h4 v-show="editMode" class="modal-title">Update</h4>
            </div>
            <form
              @submit.prevent="
                editMode ? updateGroupCustomer() : createGroupCustomer()
              "
            >
              <div class="modal-body">
                
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Branch <span class="red">*</span></label>
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                              @change="getMemberAndGroup"
                            >
                              <option v-if="!form.branch_id" selected value="">
                                Select branch
                              </option>
                              <option
                                :value="bra.id"
                                v-for="bra in branches"
                                :key="bra.id"
                              >
                                {{ bra.name }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Group <span class="red">*</span></label>
                            
                            <v-select v-model="colC" name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="getCollectionCenter">
                            </v-select>
                            <has-error
                              :form="form"
                              field="collection_center_id"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Member <span class="red">*</span></label>
                            
                            <v-select v-model="mem"  name="member_id" label="name" :options="members" placeholder="Select Member" v-on:input="getBranchMember">
                              
                            </v-select>
                            <has-error
                              :form="form"
                              field="member_id"
                            ></has-error>
                          </div>

                          <!-- <div class="form-group">
                              <label>Select Status <span class="red">*</span></label>
                              <select v-model="form.status" name="status"
                                  class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                  <option v-if="!form.status" selected value="">Select Status</option>
                                  <option value="active">Active</option>
                                  <option value="inActive">Inactive</option>
                                  
                              </select>
                              <has-error :form="form" field="status"></has-error>
                            </div> -->
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
               
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
import { mapState } from 'vuex'
export default {
  name: 'CustomerGroup',
  computed: {
    ...mapState([
      'user'
    ])
  },
  mixins: [GetBranch],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      member_city_search: '',
      editMode: false,
      collectionCenters: [],
      collectionCenter: {},
      colC: {},
      branches: [],
      branch: {},
      members: [],
      mem: {},
      getSettingRecord: '',
      userStatus: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: '',
        branch_id: '',
        status: ''
      }),
      // columns: [
      //   {
      //     label: 'GROUP NAME',
      //     field: 'collection_center.name'
      //   },

      //   {
      //     label: 'GROUP CODE',
      //     field: 'collection_center.centerCode'
      //   },
      //   {
      //     label: 'MEMBER NAME',
      //     field: 'member.name'
      //   },

      //   {
      //     label: 'MEMBER CODE',
      //     field: 'member.code'
      //   },
      //   {
      //     label: 'MOBILE NUMBER',
      //     field: 'member.mobile'
      //   },
      //   {
      //     label: 'BRANCH NAME',
      //     field: 'branch.name'
      //   },

      //   {
      //     label: 'BRANCH CODE',
      //     field: 'branch.branchCode'
      //   },

      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.colC = {}
      this.mem = {}
      this.form.reset()
      this.getMemberAndGroup()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.getSettingRecord = data.enableMandatoryCustomerKyc
        })
        .catch(function (error) {
          console.log(error)
        })
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    getBranchMember () {
      this.form.member_id = this.mem.user_id
    },
    getCollectionCenter () {
      this.form.collection_center_id = this.colC.id
    },
    createGroupCustomer () {
      this.$axios
        .post('collectioncentermember', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Member Added in Group Successfully'
          })
        })
        .catch(
          function (error) {
            Swal.fire('Failed!', error.response.data.error, 'error')
            // Toast.fire({ icon: 'error', title: error.response.data.error })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    editModal (row) {
      this.editMode = true

      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.getMemberAndGroup()
    },
    updateGroupCustomer () {
      // console.log('update data')

      this.$axios
        .put('collectioncentermember/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Group Member Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getMemberAndGroup () {
      // var c = JSON.parse(localStorage.user)
      // if (c.type === 'staff') {
      //   this.form.branch_id = c.agent_profile.branch_id
      // }
      this.userStatus = ''
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios
        .get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'collectioncentermember'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      // if (c.type !== 'admin') {
      //   if (c.role.name === 'Manager') {
      //     pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      //   } else {
      //     pageUrl += `&agent_id=${c.id}`
      //   }
      // } else {
      //   if (this.branch.id) {
      //     pageUrl += `&branch_id=${this.branch.id}`
      //   }
      // }
      if (this.table_search) {
        pageUrl += `&collectionCenterCity=${this.table_search}`
      }
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (c.role.name === 'Agent') {
        pageUrl += `&agent_id=${c.id}`
      }
      if (this.member_city_search) {
        pageUrl += `&memberCity=${this.member_city_search}`
      }
      if (this.collectionCenter.id) {
        pageUrl += `&collection_center_id=${this.collectionCenter.id}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    getDataBranchWise (branch) {
      if (branch) {
        this.branch.id = branch.id
      }
      this.form.branch_id = this.branch.id
      this.collectionCenters = []
      this.collectionCenter = {}
      this.getCollectionCenterList()
      this.changeFilter()
    },
    getCollectionCenterList () {
      // var c = JSON.parse(localStorage.user)
      // if (c.type === 'staff') {
      //   this.form.branch_id = c.agent_profile.branch_id
      // }
      let loader = this.$loading.show()
      this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          // $('#newModal').modal({backdrop: 'static', keyboard: false})
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
          this.branch = data.data[0].branch
        })
        .catch(
          function (error) {
            loader.hide()
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.error
            })
            this.$router.push({'path': '/Error403'})
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('collectioncentermember?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  },

  created () {
    // this.loadMember()
    // var c = JSON.parse(localStorage.user)
    // if (c.type === 'staff') {
    //   this.form.branch_id = c.agent_profile.branch_id
    //   this.getCollectionCenterList()
    // }
    this.changeFilter()
    this.getBranch()

    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>




// WEBPACK FOOTER //
// CustomerGroup.vue?f71c3266